import { useState } from 'react';
import { stats } from '@/mocks/bookData';

export default function Hero() {
  const [keyword, setKeyword] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    document.getElementById('ranking')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="relative h-[560px] md:h-[620px] w-full">
        <img
          src="https://readdy.ai/api/search-image?query=artistic%20isometric%20illustration%20of%20a%20warm%20cozy%20book%20house%20library%20at%20dusk%20with%20floating%20open%20books%2C%20paper%20airplane%2C%20ink%20brushes%20and%20whimsical%20bookmarks%2C%20warm%20cream%20amber%20and%20jade%20green%20palette%2C%20stylized%20editorial%20vector%20art%2C%20soft%20light%2C%20lots%20of%20negative%20space%20on%20the%20upper%20area&width=1800&height=900&seq=yuzhai-hero&orientation=landscape"
          alt="御宅书屋的温暖书卷插图背景"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/40 via-background-950/30 to-background-50"></div>

        <div className="relative z-10 mx-auto flex h-full w-full max-w-5xl flex-col items-center justify-center px-4 text-center">
          <span className="mb-5 inline-flex items-center gap-2 rounded-full bg-background-50/20 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur-sm">
            <i className="ri-fire-line"></i>
            人气排行 · 口碑榜单 · 每日实时更新
          </span>

          <h1 className="font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl lg:text-6xl">
            御宅书屋
            <span className="mt-2 block text-lg font-semibold text-background-100 md:text-2xl">
              同好的书架，也是你的书单
            </span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
            聚合读者评分、热议作品与打卡排行，呈现最新人气排行与口碑榜单。
            点开查看同好真实推荐与评分详情，快速掌握大家都在追什么、哪些作品值得补。
          </p>

          <form
            onSubmit={handleSearch}
            className="mt-8 flex w-full max-w-xl flex-col gap-2 sm:flex-row sm:items-center"
          >
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-lg text-foreground-500"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索书名 / 作者 / 题材，如「剑冢」"
                className="h-12 w-full rounded-full bg-background-50 pl-11 pr-4 text-sm text-foreground-900 placeholder:text-foreground-500 outline-none focus:ring-2 focus:ring-primary-400"
              />
            </div>
            <button
              type="submit"
              className="flex h-12 items-center justify-center gap-2 rounded-full bg-primary-500 px-7 text-sm font-semibold text-background-50 transition hover:bg-primary-600 whitespace-nowrap"
            >
              <i className="ri-book-open-line"></i>
              开始找书
            </button>
          </form>

          <dl className="mt-10 grid w-full max-w-2xl grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-xl bg-background-50/15 px-3 py-4 backdrop-blur-sm">
                <dt className="order-2 mt-1 text-xs text-background-100">{s.label}</dt>
                <dd className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}